import React from 'react';
import {
    Switch,
    Redirect,
    withRouter
} from "react-router-dom";
import {createBrowserHistory} from 'history';
import {createTheme, ThemeProvider} from "@mui/material/styles";

import './App.css';
import Autorize from './routes/authorize';
import NonAutorize from './routes/non-authorize';

import {NonAuthorizeContainer} from './containers/NonAuthorizeContainer/NonAuthorizeContainer';
import {AuthorizeContainer} from './containers/AuthorizeContainer/AuthorizeContainer';
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import "react-datepicker/dist/react-datepicker.css";
import {Hoc} from './hoc';

const history = createBrowserHistory()

function App() {
    const theme = createTheme();

    return (
        <ThemeProvider theme={theme}>
            <Container>
                <Hoc>
                    <CssBaseline/>
                    <Switch>
                        {NonAutorize.map((obj) => {
                            return <NonAuthorizeContainer key={obj.path}
                                                          history={history}
                                                          path={obj.path}
                                                          component={obj.component}/>
                        })}}

                        {Autorize.map((obj) => {
                            return <AuthorizeContainer key={obj.path}
                                                       history={history}
                                                       path={obj.path}
                                                       component={obj.component}/>
                        })}

                        <Redirect from='/' to='/signin'/>
                    </Switch>
                </Hoc>
            </Container>
        </ThemeProvider>

    );
};

export default withRouter(App);
